
import { TableCell, TableRow } from '@/components/ui/table';
import { DateTime } from 'luxon';
import { ReportDetail } from '@/types/salary';

interface TeacherReportTableRowProps {
  report: ReportDetail;
}

export function TeacherReportTableRow({ report }: TeacherReportTableRowProps) {
  return (
    <TableRow>
      <TableCell>
        {DateTime.fromISO(report.teaching_date).toFormat('d/M/yyyy')}
      </TableCell>
      <TableCell>
        {report.class_type} {report.is_inter ? "Inter" : ""}
      </TableCell>
      <TableCell>{report.tier}</TableCell>
      <TableCell>
        {report.grade === "primary" ? "ประถม" : 
         report.grade === "high_school" ? "มัธยม" : "พิเศษ"}
      </TableCell>
      <TableCell>
        {`${report.student_full_name} (${report.student_nickname})`}
      </TableCell>
      <TableCell className="text-center">
        {report.is_late_submit ? "✓" : "-"}
      </TableCell>
      <TableCell className="text-center">
        {report.has_sheet ? (
          report.has_sheet && report.sheet_approve_status === 'REJECTED' ? (
            <span className="text-red-500">มี (ไม่ผ่าน)</span>
          ) : (
            <span>มี</span>
          )
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell className="text-center">
        {report.sudden_leave ? "✓" : "-"}
      </TableCell>
      <TableCell className="text-right">{report.duration}</TableCell>
      <TableCell className="text-right">
        {report.salary.toLocaleString()}
      </TableCell>
    </TableRow>
  );
}
